/**
 * @generated SignedSource<<0aa41c7e4bf8a355956afe84a4f1242e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GraphQLJobRunStatus = "COMPLETED" | "ERRORED" | "IN_PROGRESS" | "PENDING" | "STOPPED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DigestJobRunList_job$data = {
  readonly id: any;
  readonly inputJson: any;
  readonly jobRuns: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly completedAt: any | null | undefined;
        readonly createdAt: any;
        readonly id: any;
        readonly startedAt: any | null | undefined;
        readonly status: GraphQLJobRunStatus;
        readonly updatedAt: any;
      };
    }>;
  };
  readonly name: string;
  readonly schedule: any | null | undefined;
  readonly " $fragmentType": "DigestJobRunList_job";
};
export type DigestJobRunList_job$key = {
  readonly " $data"?: DigestJobRunList_job$data;
  readonly " $fragmentSpreads": FragmentRefs<"DigestJobRunList_job">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DigestJobRunList_job",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "schedule",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inputJson",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 20
        },
        {
          "kind": "Literal",
          "name": "sortBy",
          "value": "started_at"
        },
        {
          "kind": "Literal",
          "name": "sortOrder",
          "value": "desc"
        }
      ],
      "concreteType": "GraphQLJobRunConnection",
      "kind": "LinkedField",
      "name": "jobRuns",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLJobRunEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLJobRun",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "completedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "jobRuns(limit:20,sortBy:\"started_at\",sortOrder:\"desc\")"
    }
  ],
  "type": "GraphQLJob",
  "abstractKey": null
};
})();

(node as any).hash = "10259d6007925a05c2f4c1e24de6d0e6";

export default node;
